import { useParams } from 'react-router'

import { DataHealthCheckList } from 'layout-components/general/data-connections/data-health-check-list'
import { useFetchConnectedSourceSystem } from 'layout-components/general/data-connections/queries/fetch-connected-source-system'
import { DataConnectionMode } from 'layout-components/general/data-connections/types'

export function DataIntegrityChecksTab({ mode }: { mode: DataConnectionMode }) {
  const { id } = useParams<{ id: string }>()
  const { isPending, data: connectedSourceSystem } = useFetchConnectedSourceSystem({ id })

  if (isPending) return <div>Loading...</div>

  return <DataHealthCheckList connectedSourceSystem={connectedSourceSystem} />
}
